import React from 'react';
import { Box, Container, Step, StepLabel, Stepper } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import PageMeta from 'components/seo/PageMeta';
import ErrorBoundary from 'components/feedback/ErrorBoundary';
import { ROUTES } from 'config/routes';

const steps = ['Carrito', 'Envío', 'Pago', 'Confirmación'];

const resolveActiveStep = (pathname: string): number => {
  if (pathname.includes('/pedido/confirmacion')) return 3;
  if (pathname === ROUTES.CHECKOUT || pathname.startsWith(`${ROUTES.CHECKOUT}/`)) return 1;
  if (pathname === ROUTES.CART) return 0;
  return 1;
};

const CheckoutLayout: React.FC = () => {
  const location = useLocation();
  const activeStep = resolveActiveStep(location.pathname);

  return (
    <>
      <PageMeta title="Checkout" />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <Box>
          <ErrorBoundary variant="page">
            <Outlet />
          </ErrorBoundary>
        </Box>
      </Container>
    </>
  );
};

export default CheckoutLayout;
